import { createSlice } from '@reduxjs/toolkit';
import type { NormalizedError } from 'errors/types';
import type { RootState } from 'state/store';

export type RequestCallbackLeadDetails = {
  firstName?: string | null;
  lastName?: string | null;
  email: string | null;
  phoneNumber: string | null;
  address: string | null;
  postcode: string | null;
};

export type RequestCallbackLeadState = {
  isLoading: boolean;
  isFormOpen: boolean;
  errors: null | NormalizedError[];
  details: RequestCallbackLeadDetails;
  data: {
    status: string | null;
  };
};

export const initialState: RequestCallbackLeadState = {
  isLoading: false,
  errors: null,
  isFormOpen: false,
  details: {
    firstName: null,
    lastName: null,
    email: null,
    phoneNumber: null,
    address: null,
    postcode: null
  },
  data: {
    status: null
  }
};

export const slice = createSlice({
  name: 'requestCallbackLead',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
      state.isFormOpen = true;
    },
    setIsFormOpen: (state, { payload }) => {
      state.isFormOpen = payload;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.isFormOpen = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.isFormOpen = true;
      state.data = {
        status: null
      };
      state.errors = payload;
    },
    setFormField: (state, { payload: { name, value } }) => {
      state.details[name] = value;
    }
  }
});

export const {
  setInitialState,
  setFormField,
  setSuccess,
  setError,
  setIsLoading,
  setIsFormOpen
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectDetails = (state: RootState) => selectSlice(state).details;
export const selectIsLoading = (state: RootState) =>
  selectSlice(state).isLoading;
export const selectIsFormOpen = (state: RootState) =>
  selectSlice(state).isFormOpen;
export const selectErrors = (state: RootState) => selectSlice(state).errors;
export const selectStatus = (state: RootState) =>
  selectSlice(state).data.status;
export default slice.reducer;
